import React, { useState, useEffect, useRef } from "react";
import "./App.css";

const ErrorText = () => (
  <p className="App-error-text">Geolocation is not available</p>
);

export default () => {
  const [isAvailable, setAvailable] = useState(false);
  const [position, setPosition] = useState({ latitude: null, longitude: null });
  const [address, setAddress] = useState("");

  const isFirstRef = useRef(true);

  useEffect(() => {
    isFirstRef.current = false;
    if ("geolocation" in navigator) {
      setAvailable(true);
    }
  }, [isAvailable]);

  const getCurrentPosition = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      setPosition({ latitude, longitude });
      fetchAddress(latitude, longitude);
    });
  };

  const fetchAddress = async (lat, lng) => {
    const apiKey = process.env.REACT_APP_GOOGLE_API_KEY; // 環境変数から API キーを取得

    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      if (data.status === "OK") {
        const address = data.results[0].formatted_address;
        setAddress(address);
      } else {
        console.error("Geocoding failed:", data.status);
      }
    } catch (error) {
      console.error("Failed to fetch address:", error);
    }
  };

  if (isFirstRef.current) return <div className="App">Loading...</div>;

  return (
    <div className="container">
      <h1>ボタンがクリックされた位置を表示</h1>
      {!isFirstRef && !isAvailable && <ErrorText />}
      {isAvailable && (
        <div>
          <div className="buttonContainer">
            <button className="button" onClick={getCurrentPosition}>
              現在地を取得
            </button>
          </div>
          <div className="result">
            <div className="lalt">
              <p className="title">緯度</p>
              <p className="value"> {position.latitude}</p>
              <p className="title">経度</p>
              <p className="value"> {position.longitude}</p>
            </div>
            <div className="address">
              <p className="title">住所</p>
              <p className="value">{address}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
